import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY, Observable } from 'rxjs';
import { Beneficjent } from '../../shared/models/beneficjent';
import { HttpResponseService } from '../../core/services/http-error-response.service';
import { AuthApi } from '../../shared/services/api/auth.api';

export const firstLoginResolver: ResolveFn<Observable<Beneficjent>> = (
  route: ActivatedRouteSnapshot,
): Observable<Beneficjent> => {
  const authApi = inject(AuthApi);
  const httpResponseService = inject(HttpResponseService);
  const router = inject(Router);
  return authApi.getCurrentUserByPreAuthCookie$().pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania użytkownika.',
      );
      router.navigate(['/']);
      return EMPTY;
    }),
  );
};
